/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createMessageApiV1MessagePost } from '../fn/message/create-message-api-v-1-message-post';
import { CreateMessageApiV1MessagePost$Params } from '../fn/message/create-message-api-v-1-message-post';
import { getMessagesApiV1MessageSessionSessionIdGet } from '../fn/message/get-messages-api-v-1-message-session-session-id-get';
import { GetMessagesApiV1MessageSessionSessionIdGet$Params } from '../fn/message/get-messages-api-v-1-message-session-session-id-get';
import { MessageRead } from '../models/message-read';

@Injectable({ providedIn: 'root' })
export class MessageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createMessageApiV1MessagePost()` */
  static readonly CreateMessageApiV1MessagePostPath = '/api/v1/message';

  /**
   * Create Message.
   *
   * Create a new message
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMessageApiV1MessagePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  createMessageApiV1MessagePost$Response(params?: CreateMessageApiV1MessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageRead>> {
    return createMessageApiV1MessagePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Message.
   *
   * Create a new message
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMessageApiV1MessagePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createMessageApiV1MessagePost(params?: CreateMessageApiV1MessagePost$Params, context?: HttpContext): Observable<MessageRead> {
    return this.createMessageApiV1MessagePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MessageRead>): MessageRead => r.body)
    );
  }

  /** Path part for operation `getMessagesApiV1MessageSessionSessionIdGet()` */
  static readonly GetMessagesApiV1MessageSessionSessionIdGetPath = '/api/v1/message/session/{session_id}';

  /**
   * Get Messages.
   *
   * Get all messages for a specific session
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMessagesApiV1MessageSessionSessionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMessagesApiV1MessageSessionSessionIdGet$Response(params: GetMessagesApiV1MessageSessionSessionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MessageRead>>> {
    return getMessagesApiV1MessageSessionSessionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Messages.
   *
   * Get all messages for a specific session
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMessagesApiV1MessageSessionSessionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMessagesApiV1MessageSessionSessionIdGet(params: GetMessagesApiV1MessageSessionSessionIdGet$Params, context?: HttpContext): Observable<Array<MessageRead>> {
    return this.getMessagesApiV1MessageSessionSessionIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MessageRead>>): Array<MessageRead> => r.body)
    );
  }

}
